export default {
  name: 'Welcome',
  props: {
    msg: String
  }
}